import { render, staticRenderFns } from "./DropzoneFileUpload.vue?vue&type=template&id=84baf8e2&"
import script from "./DropzoneFileUpload.vue?vue&type=script&lang=js&"
export * from "./DropzoneFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports